module.exports = __webpack_public_path__ + "img/white_logo.4e6ba34b.png";